import { DialogType } from '@tableau/widgets';
import React = require('react');
import { CommonStyles } from '../../common/react/CommonStyles';
import { ModalInstance, ReactModalService } from '../../commonInfra/dialogs/ReactModalService';
import { Set } from '../../ts/models/Set';
import { SetSiteUsersRoleDialog } from '../components/SetSiteUsersRoleDialog';
import { ISiteUserInfo } from '../users/models/ISiteUserInfo';

const SetSiteUsersRoleDialogStyle: React.CSSProperties = {
  width: 'auto',
  height: 'auto',
  paddingTop: CommonStyles.Sizes.MediumSpace,
  paddingLeft: CommonStyles.Sizes.MediumSpace,
  paddingRight: CommonStyles.Sizes.MediumSpace
};

function showSetSiteUsersSiteRoleDialog(siteUsersToSet: Set<ISiteUserInfo>) {
  let modalInstance: ModalInstance<unknown>;
  const dialogProps = {
    close: () => modalInstance && modalInstance.close({}),
    dismiss: () => modalInstance && modalInstance.dismiss('cancel'),
    siteUsersToSet: siteUsersToSet
  };

  modalInstance = ReactModalService.open({
    type: DialogType.Uber,
    dialogContent: React.createElement(SetSiteUsersRoleDialog, dialogProps),
    testId: 'setSiteUsersRoleDialog',
    showCloseButton: true,
    dialogStyle: SetSiteUsersRoleDialogStyle,
    dialogBodyStyle: {overflow: 'hidden'},
    shouldNotSetDefaultWidth: true
  });
  return modalInstance.result;
}

export const SetSiteUsersSiteRoleAction = {
  showSetSiteUsersSiteRoleDialog
};
